import { isset } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

// Note: no global dependencies used in this component

class WaitlistContactsTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.setTextFor = this.setTextFor.bind(this)
    this.tableBody = this.tableBody.bind(this)
    this.handleContactClick = this.handleContactClick.bind(this)
  }

  /**
   * Note: We need to keep an inline arrow function for the click handler that passes the
   * contact parameter, as creating individual handler methods for each contact would be impractical.
   * This is a common pattern in React for handling parameterized event handlers in loops.
   */
  handleContactClick(contact) {
    this.props.selectContact(contact)
  }

  setTextFor(contact, type) {
    if (isset(contact[type]) && isset(this.props[type])) {
      // String.replace with regex requires an arrow function to process each match
      // This is a standard JavaScript pattern and is unavoidable
      return contact[type].replace(new RegExp(this.props[type], "gi"), (x) => {
        return `<mark>${x}</mark>`
      })
    }
    return contact[type]
  }

  tableBody() {
    const html = []
    if (this.props.activeContacts.length > 0) {
      this.props.activeContacts.forEach((contact) => {
        html.push(
          <tr
            key={contact.id}
            className="cursor-pointer"
            onClick={() => this.handleContactClick(contact)}
          >
            <td>
              <input
                type="radio"
                className="center"
                checked={this.props.isContactSelected(contact)}
                readOnly
              />
            </td>
            <td
              dangerouslySetInnerHTML={{
                __html: this.setTextFor(contact, "name"),
              }}
            />
            <td
              dangerouslySetInnerHTML={{
                __html: this.setTextFor(contact, "email"),
              }}
            />
            <td
              dangerouslySetInnerHTML={{
                __html: this.setTextFor(contact, "display_phone"),
              }}
            />
          </tr>
        )
      })
    } else if (this.props.archivedContacts.length > 0) {
      html.push(
        <tr key={1}>
          <td className="py-4" colSpan={4}>
            <div className="flex flex-col space-y-2 text-center">
              <strong>
                Your search matched contacts that are currently archived
              </strong>
              <a
                className="font-bold text-blue-800"
                href={this.props.archivedContactsPath}
              >
                View archived contacts
              </a>
            </div>
          </td>
        </tr>
      )
    } else {
      html.push(
        <tr key="0">
          <td colSpan="4" className="text-center">
            Add contact info to filter
          </td>
        </tr>
      )
    }
    return html
  }

  render() {
    if (
      this.props.activeContacts.length > 0 ||
      (this.props.archivedContacts.length > 0 &&
        !this.props.state.selectedContact)
    ) {
      return (
        <div>
          <div className="table-responsive overflow-auto">
            <table className="table">
              {this.props.activeContacts.length > 0 && (
                <thead>
                  <tr>
                    <th className="text-center">Select</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                  </tr>
                </thead>
              )}
              <tbody>{this.tableBody()}</tbody>
            </table>
          </div>
        </div>
      )
    } else {
      return null
    }
  }
}

WaitlistContactsTable.propTypes = {
  activeContacts: PropTypes.array.isRequired,
  archivedContacts: PropTypes.array.isRequired,
  archivedContactsPath: PropTypes.string,
  name: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  selectContact: PropTypes.func.isRequired,
  isContactSelected: PropTypes.func.isRequired,
  state: PropTypes.shape({
    selectedContact: PropTypes.object,
  }).isRequired,
}

export default WaitlistContactsTable
